import { css } from '@emotion/react'

export const button = css`
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  width: 100%;
  cursor: pointer;
`

export const link = css`
  width: 100%;
  cursor: pointer;
  text-decoration: none;
`
